import React, { useCallback, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { Form } from '@unform/web';

import { mutate as mutateGlobal } from 'swr';
import { useFetchPeople } from './hooks/useFetchPeople';
import { useToast } from '../../hooks/toast';

import api from '../../services/api';

import ButtonPrimaryGree from '../../components/ButtonPrimaryGreen';
import InputSearch from '../../components/Form/InputSearch';
import NavbarMenu from '../../components/NavbarMenu';
import ContainerBox from '../../components/ContainerBox';
import ButtonGroupbox from '../../components/ContainerBox/ButtonGroupbox';
import Table from './Table';

import Loading from '../../components/Loading';
import Pagination from '../../components/Pagination';

import { Container, TotalItems } from './styles';

const People = () => {
  const formRef = useRef(null);
  const { addToast } = useToast();

  const [page, setPage] = useState(1);
  const [url, setUrl] = useState('/peoples');
  const [showPeoples, setShowPeoples] = useState(true);

  const { dataList: peoples, loading, totalItems } = useFetchPeople(
    `/peoples?page=${page}`
  );

  const { dataList: searchPeoples, loading: loadingSearch } = useFetchPeople(
    url
  );

  const head = {
    id: 'ID',
    name: 'Nome',
    cpfcnpj: 'CNPJ / CPF',
    phone: 'Telefone',
    active: 'Status',
  };

  const handleSubmit = useCallback(() => {
    const input = formRef.current.getFieldValue('inputpeople');

    if (!input) {
      setUrl('/peoples?page=1');
      setPage(1);
      setShowPeoples(true);

      return;
    }

    setUrl(`/peoplesearch?search=${input}`);
    setShowPeoples(false);
    formRef.current.reset();
  }, []);

  const handleEnter = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        handleSubmit();
      }
    },
    [handleSubmit]
  );

  const handlePeopleDelete = useCallback(
    async (id) => {
      try {
        if (
          window.confirm(`Tem Certeza que realmente deseja excluir o registro?`)
        ) {
          await api.delete(`/peoples/${id}`);

          mutateGlobal(`/peoples?page=${page}`);
          mutateGlobal(url);

          addToast({
            type: 'success',
            title: 'Cadastro Excluido com Sucesso',
          });
        } else {
          return;
        }
      } catch (err) {
        if (err.response.status === 400) {
          addToast({
            type: 'error',
            title:
              'Não pode excluir uma pessoa vinculada a movimentações do sistema',
          });
          return;
        }
        addToast({
          type: 'error',
          title: 'Não foi possível excluir o registro. Verifique',
        });
      }
    },
    [addToast, page, url]
  );

  return (
    <Container>
      <NavbarMenu />
      <ContainerBox title="Pessoas: Clientes, Fornecedores, Colaborador, Transportadora">
        <ButtonGroupbox>
          <Link to="/peoples/newedit">
            <ButtonPrimaryGree icon={FiPlus}>Adicionar</ButtonPrimaryGree>
          </Link>

          <Form ref={formRef} onSubmit={() => {}}>
            <InputSearch
              id="inputpeople"
              name="inputpeople"
              autoComplete="off"
              onKeyDown={(e) => handleEnter(e)}
              handleClick={handleSubmit}
            />
          </Form>
        </ButtonGroupbox>

        {showPeoples && loading && <Loading />}
        {showPeoples && !loading && peoples && (
          <>
            <Table
              head={head}
              data={peoples}
              handleDelete={handlePeopleDelete}
              pathname="/peoples/newedit"
            />
            {totalItems && (
              <TotalItems>
                <span>
                  Total de registro(s): <b>{totalItems}</b>
                </span>
              </TotalItems>
            )}
            {totalItems > 20 && (
              <Pagination
                setPage={setPage}
                currentPage={page}
                totalItems={totalItems}
              />
            )}
          </>
        )}
        {!showPeoples && loadingSearch && <Loading />}
        {!showPeoples && !loadingSearch && searchPeoples && (
          <Table
            head={head}
            data={searchPeoples}
            handleDelete={handlePeopleDelete}
            pathname="/peoples/newedit"
          />
        )}
      </ContainerBox>
    </Container>
  );
};

export default People;
